export const EODINTERVALS = {
  RSLEVEL_CLASSIC: ["Daily", "Weekly", "Monthly"],
  RS_LEVEL_FIBBO: ["Daily", "Weekly", "Monthly"],
  Returns: ["Daily", "Weekly", "Monthly"],
  Volume_Analysis: ["Daily", "Weekly", "Monthly"],
  MeanReversion: ["Daily", "Weekly", "Monthly"],
  Default: ["Daily", "Weekly", "Monthly"],
};

export const canExportToCSV = true;
